import axios from '../../axios'

//获取所有老师信息
export const getTeacherInfo = data => {
    return axios({
        url: '/api/base/aboard/teacher',
        method: 'get',
        data:data.data
    })
}

//删除
export const delOneTeacherInfo = data => {
    return axios({
        url: '/api/base/aboard/teacher',
        method: 'DELETE',
        data
    })
}

//编辑或新增
export const editOneTeacherInfo = data => {
           return axios({
               url: '/api/base/aboard/teacher',
               method: data.method || 'GET',
               data:data.data
           })
}
       

//查看名师极少内容信息

export const showOneTeacherInfo = data => {
           return axios({
               url: '/api/base/aboard/teacher/intro',
               method: 'GET',
               data
           })
}



// WEBPACK FOOTER //
// ./src/http/moudules/adroad/teacher.js